<app-navbar></app-navbar>
<div class="container-fluid mt-2">
    <router-outlet></router-outlet>
</div>
